export default {
  All: null,
  PayWithSalary: true,
  NotPayWithSalary: false,
};
